<template>
  <div class="no-data-container">
    <img src="../../common/img/no-course.png" alt="" srcset="">
    <p class="no-data-tips">{{ tips || '暂无数据' }}</p>
  </div>
</template>

<script>
export default {
  props: ['tips']
}
</script>

<style lang="less" scoped>
.no-data-container{
  display: flex;
  flex-direction: column;
  align-items: center;
  img{
    width: 30%;
  }
  .no-data-tips{
    font-size: 14px;
    margin-top: 15px;
    color: #999;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Public/NoData.vue